export default __webpack_public_path__ + "static/media/sideimg.cd36541c.png";